import { lazy } from "react";
import { BsWindowSidebar } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { MdOutlineDashboard, MdOutlinePlace } from "react-icons/md";
import { PiCarProfileLight, PiHeadphones } from "react-icons/pi";
import {
  TbBrandBooking,
  TbBulb,
  TbCalendar,
  TbCar,
  TbCarCrash,
  TbCategoryPlus,
  TbFileReport,
  TbFileText,
  TbHelpCircle,
  TbNews,
  TbSpeakerphone,
  TbUsersGroup,
} from "react-icons/tb";

const Newsletter = lazy(() => import("../pages/Newsletter"));
const Subscription = lazy(() => import("../pages/Subscription"));
const SupportRequest = lazy(() => import("../pages/SupportRequest"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const UserManagement = lazy(() => import("../pages/UserManagement"));
const ViewUser = lazy(() => import("../pages/UserManagement/ViewUser"));
const Cms = lazy(() => import("../pages/Cms"));
const ProfileSettings = lazy(() => import("../pages/ProfileSettings"));
const Login = lazy(() => import("../pages/Login"));
const Notifications = lazy(() => import("../pages/Notifications"));
const VehicleListing = lazy(() => import("../pages/VehicleListing"));
const VehicleDetail = lazy(() =>
  import("../pages/VehicleListing/VehicleDetail")
);
const RealEstateDetail = lazy(() => import("../pages/RealEstateDetail"));
const BrandsPage = lazy(() => import("../pages/Crud/Brands"));
const Faq = lazy(() => import("../pages/Crud/Faq"));
const Announcements = lazy(() => import("../pages/Crud/Announcements"));
const Suggesstions = lazy(() => import("../pages/Crud/Suggesstions"));
const Instructions = lazy(() => import("../pages/Crud/Instructions"));
const Models = lazy(() => import("../pages/Crud/Models"));
const BodyType = lazy(() => import("../pages/Crud/BodyType"));
const Facilities = lazy(() => import("../pages/Crud/Facilities"));
const MarketPlace = lazy(() => import("../pages/MarketPlace"));
const AddMarketPlace = lazy(() =>
  import("../pages/MarketPlace/AddMarketPlace")
);
const EditMarketPlace = lazy(() =>
  import("../pages/MarketPlace/EditMarketPlace")
);
const MarketPlaceViewDetail = lazy(() =>
  import("../pages/MarketPlace/ViewDetail")
);
const Availability = lazy(() => import("../pages/Crud/Availablity"));
const ReportsManagement = lazy(() => import("../pages/Reports Management"));
const InteriorWear = lazy(() => import("../pages/Crud/InteriorWear"));

export const routes = [
  {
    path: "/login",
    exact: true,
    element: <Login />,
    protected: false,
    showInSidebar: false,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <MdOutlineDashboard />,
    element: <Dashboard />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Users",
    icon: <TbUsersGroup />,
    element: <UserManagement />,
  },
  {
    path: "/user-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <ViewUser />,
  },

  {
    path: "/vehicle-listing",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Vehicle Listing",
    icon: <PiCarProfileLight />,
    element: <VehicleListing />,
  },
  {
    path: "/reports-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Reports Management",
    icon: <TbFileReport />,
    element: <ReportsManagement />,
  },
  {
    path: "/vehicle-listing/:id",
    exact: true,
    protected: true,
    element: <VehicleDetail />,
  },
  {
    path: "/market-place",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Market Place",
    icon: <MdOutlinePlace />,
    element: <MarketPlace />,
  },
  {
    path: "/market-place/add",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddMarketPlace />,
  },
  {
    path: "/market-place/edit/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <EditMarketPlace />,
  },
  {
    path: "/market-place/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <MarketPlaceViewDetail />,
  },

  {
    path: "/real-estate/:id",
    exact: true,
    protected: true,
    element: <RealEstateDetail />,
  },
  {
    path: "/subscription",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Subscription",
    icon: <HiOutlineCurrencyDollar />,
    element: <Subscription />,
  },
  {
    path: "/newsletter",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Newsletter",
    icon: <TbNews />,
    element: <Newsletter />,
  },
  {
    path: "/support-request",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Support",
    icon: <PiHeadphones />,
    element: <SupportRequest />,
  },
  {
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CRUD",
    icon: <TbCategoryPlus />,
    subMenu: [
      {
        showInSidebar: true,
        path: "/brands",
        title: "Brands",
        element: <BrandsPage />,
        icon: <TbBrandBooking />,
      },
      {
        showInSidebar: true,
        path: "/faq",
        title: "FAQ",
        element: <Faq />,
        icon: <TbHelpCircle />,
      },
      {
        showInSidebar: true,
        path: "/announcements",
        title: "Announcements",
        element: <Announcements />,
        icon: <TbSpeakerphone />,
      },
      {
        showInSidebar: true,
        path: "/suggesstions",
        title: "Suggesstions",
        element: <Suggesstions />,
        icon: <TbBulb />,
      },
      {
        showInSidebar: true,
        path: "/instructions",
        title: "Instructions",
        element: <Instructions />,
        icon: <TbFileText />,
      },
      {
        showInSidebar: true,
        path: "/models",
        title: "Models",
        element: <Models />,
        icon: <TbCar />,
      },
      {
        showInSidebar: true,
        path: "/body-types",
        title: "Body Types",
        element: <BodyType />,
        icon: <TbCarCrash />,
      },
      {
        showInSidebar: true,
        path: "/facilities",
        title: "Facilities",
        element: <Facilities />,
        icon: <TbCarCrash />,
      },
      {
        showInSidebar: true,
        path: "/availability",
        title: "Availability",
        element: <Availability />,
        icon: <TbCalendar />,
      },
      {
        showInSidebar: true,
        path: "/interior-wear",
        title: "Interior Wear",
        element: <InteriorWear />,
        icon: <TbCarCrash />,
      },
    ],
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "CMS",
    icon: <BsWindowSidebar />,
    element: <Cms />,
  },
  {
    path: "/profile-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Profile Settings",
    icon: <CgProfile />,
    element: <ProfileSettings />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <Notifications />,
  },
];
